import React, { createContext, useEffect, useState } from "react";
import { Form, Input, Button, Row, Col, message, Card, Modal } from "antd";
import { useSelector } from "react-redux";
import MainLayout from "../../components/MainLayout";
import AddWarehouse from "./AddWarehouse";
import DataTables from "./DataTables";
import { ApiConfig } from "../../services/ApiConfigs";
import { ApiServices } from '../../services/apiServices';

export const WarehouseContext = createContext({})

const Warehouse = () => {
    const isFranchise = useSelector((state) => state.UserData?.userData?.role === 'franchise' || state.UserData?.userData?.user?.role === 'franchise');
    const [form] = Form.useForm();
    const [addModalOpen, setAddModalOpen] = useState(false);
    const [wareHouseData, setWarehouseData] = useState([]);
    const [selectWareHouseData, setSelectWarehouseData] = useState({});
    const [isEditMode, setIsEditMode] = useState(false);
    const [loader, setLoader] = useState(false)

    useEffect(() => {
        getWarehouse()
    }, [])

    useEffect(() => {
        if (!addModalOpen) return;
        if (Object.keys(selectWareHouseData).length > 0) {
            form.setFieldsValue({
                name: selectWareHouseData.name,
                address: selectWareHouseData.address,
                city: selectWareHouseData.city || "",
                state: selectWareHouseData.state || "",
                country: selectWareHouseData.country || "",
                pincode: selectWareHouseData.pincode || "",
                manager: selectWareHouseData.manager,
                contactPhone: selectWareHouseData.contactPhone,
                latitude: selectWareHouseData.latitude,
                longitude: selectWareHouseData.longitude,
                deliveryRadiusKm: selectWareHouseData.deliveryRadiusKm !== undefined && selectWareHouseData.deliveryRadiusKm !== null
                    ? Number(selectWareHouseData.deliveryRadiusKm)
                    : 10,
                radiusEnabled: !!selectWareHouseData.radiusEnabled,
            });
            setIsEditMode(true);
        } else {
            setIsEditMode(false);
            form.resetFields();
            form.setFieldsValue({ deliveryRadiusKm: 10, radiusEnabled: false });
        }
    }, [selectWareHouseData, addModalOpen, form]);


    // Handle form submission
    const onFinish = async (values) => {
        console.log("Form Submitted:", values);
        getWarehouse()
    };

    const onClose = () => {
        setAddModalOpen(false);
        setSelectWarehouseData({});
        setIsEditMode(false);
        form.resetFields();
    };

    const deleteUser = (record) => {
        const warehouseId = record?.id || record;
        const warehouseName = record?.name || 'this warehouse';
        Modal.confirm({
            title: 'Delete Warehouse',
            content: `Are you sure you want to delete "${warehouseName}"? This action cannot be undone.`,
            okText: 'Delete',
            okType: 'danger',
            cancelText: 'Cancel',
            centered: true,
            onOk: async () => {
                try {
                    const res = await ApiServices('delete', ApiConfig.WAREHOUSE + '/' + warehouseId);
                    console.log(res, "delete warehouse response..");
                    message.success('Warehouse deleted successfully');
                    getWarehouse();
                } catch (error) {
                    console.log(error);
                    message.error('Failed to delete warehouse');
                }
            },
        });
    };

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            console.log("Form Data:", values);
            if (isEditMode) {
                const response = await ApiServices("put", ApiConfig.WAREHOUSE + "/" + selectWareHouseData.id, values);
                console.log(response, "add warehouse")
                if (response.status !== 200) {
                    return message.error(response.message || "Failed to register Warehouse.");
                } else {
                    message.success("Warehouse Registered Successfully!");
                    onClose();
                    getWarehouse()
                    setIsEditMode(false)
                }
            } else {
                const response = await ApiServices("post", ApiConfig.WAREHOUSE, values);
                console.log(response, "add warehouse")
                if (response.status !== 200) {
                    return message.error(response.message || "Failed to register Warehouse.");
                } else {
                    message.success("Warehouse Registered Successfully!");
                    onClose();
                    getWarehouse()
                }
            }
        } catch (error) {
            message.error("Please fill all required fields correctly.");
        }
    };

    const getWarehouse = async () => {
        try {
            setLoader(true)
            const res = await ApiServices('get', ApiConfig.WAREHOUSE);
            console.log(res, "get warehouser")
            setWarehouseData(res?.data || [])
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.log(error)
        }
    }

    const passData = {
        form,
        onFinish,
        addModalOpen,
        setAddModalOpen,
        onClose,
        handleSubmit,
        wareHouseData,
        deleteUser,
        loader,
        isEditMode,
        setIsEditMode,
        selectWareHouseData,
        setSelectWarehouseData,
        getWarehouse,
        isFranchise,
    }

    return (
        <WarehouseContext.Provider value={passData}>
            <MainLayout>
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    flexWrap: 'wrap',
                    gap: 12,
                    marginBottom: 20 
                }}>
                    <div>
                        <h2 style={{ 
                            margin: 0, 
                            fontSize: 22, 
                            fontWeight: 700, 
                            color: '#0f172a',
                            letterSpacing: '-0.02em' 
                        }}>
                            Warehouses & Hubs
                        </h2>
                        <div style={{ fontSize: 13, color: '#64748b', marginTop: 2 }}>
                            {isFranchise 
                                ? 'View store dispatch centers and pickup locations' 
                                : 'Manage dispatch centers, pickup locations, and warehouse managers'}
                        </div>
                    </div>
                    {!isFranchise && (
                        <Button 
                            type="primary" 
                            size="large"
                            style={{
                                borderRadius: 8,
                                fontWeight: 600,
                                boxShadow: '0 2px 6px rgba(37, 99, 235, 0.25)'
                            }}
                            onClick={() => {
                                setSelectWarehouseData({});
                                setIsEditMode(false);
                                form.resetFields();
                                setAddModalOpen(true);
                            }}
                        >
                            + Add Warehouse
                        </Button>
                    )}
                </div>
                <DataTables />
                {!isFranchise && <AddWarehouse />}
            </MainLayout>
        </WarehouseContext.Provider>
    );
};

export default Warehouse;
